import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { hubFetch, setAuth, type AdminUser } from "../lib/auth.js";
import { Logo } from "../components/Logo.js";

export function LoginPage() {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setLoading(true);
    setError(null);
    try {
      const res = await hubFetch<{ token: string; admin: AdminUser }>(
        "/admin/auth/login",
        {
          method: "POST",
          body: JSON.stringify({ email: email.trim(), password }),
          requireAuth: false,
        },
      );
      setAuth(res.token, res.admin);
      navigate("/");
    } catch (err) {
      const msg = err instanceof Error ? err.message : "登录失败";
      setError(msg.includes("401") ? "邮箱或密码错误" : msg);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div
      style={{
        minHeight: "100vh",
        display: "grid",
        placeItems: "center",
        background:
          "radial-gradient(circle at 20% 20%, #eef2ff 0%, transparent 50%), radial-gradient(circle at 80% 80%, #fce7f3 0%, transparent 50%), var(--bg)",
        padding: 20,
      }}
    >
      <form
        onSubmit={handleSubmit}
        className="card"
        style={{
          width: 380,
          maxWidth: "100%",
          padding: 36,
          display: "flex",
          flexDirection: "column",
          gap: 14,
          boxShadow: "var(--shadow-lg)",
        }}
      >
        <div style={{ display: "flex", alignItems: "center", gap: 12, marginBottom: 4 }}>
          <Logo size={44} radius={12} />
          <div>
            <div style={{ fontSize: 18, fontWeight: 600, letterSpacing: "-0.01em" }}>
              mhwork-hub
            </div>
            <div style={{ fontSize: 12, color: "var(--text-muted)" }}>
              内部管理后台
            </div>
          </div>
        </div>

        <label style={styles.label}>
          <span>邮箱</span>
          <input
            type="email"
            autoFocus
            required
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            autoComplete="email"
            placeholder="name@metrichub.app"
          />
        </label>

        <label style={styles.label}>
          <span>密码</span>
          <input
            type="password"
            required
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            autoComplete="current-password"
          />
        </label>

        {error && <div className="err">{error}</div>}

        <button
          type="submit"
          className="btn btn-primary"
          style={{ height: 42, marginTop: 4 }}
          disabled={loading}
        >
          {loading ? "登录中…" : "登录"}
        </button>

        <div
          style={{
            fontSize: 11,
            color: "var(--text-muted)",
            textAlign: "center",
            marginTop: 6,
          }}
        >
          仅限授权员工 · 账号由 owner 邀请创建
        </div>
      </form>
    </div>
  );
}

const styles: Record<string, React.CSSProperties> = {
  label: {
    display: "flex",
    flexDirection: "column",
    gap: 5,
    fontSize: 12,
    fontWeight: 500,
    color: "var(--text-muted)",
  },
};
